import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { Link, useParams } from "react-router-dom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import { useCreateProjectStore } from "@/zapi-frontend/stores/createProject";
import { useProjectTemplates } from "@/zapi-frontend/widgets/CreateProjectForm/model/useProjectTemplates";
import { Typography } from "@libs/zapi-ui/custom";
import { Avatar, AvatarFallback } from "@libs/zapi-ui/shadcn";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { NotificationTrigger } from "@/zapi-frontend/features/Notifications";

export function CreateProjectHeader() {
  const { id } = useParams();
  const { isLabs } = useMeStore();
  const { projectData } = useCreateProjectStore();
  const { projectTemplates } = useProjectTemplates();

  const selectedTemplate = projectTemplates.find((t) => t.slug === projectData.projectTemplateSlug);
  const avatarLetter = selectedTemplate?.name?.[0] || projectData.name?.[0] || "P";

  return (
    <>
      <div className="flex w-full justify-between items-center">
        <div className="flex items-center gap-4">
          <Link
            data-testid="header-logo-link"
            to={getRouteProjects()}
            className="w-10 h-10 inline-flex justify-center items-center [&_svg>path]:hover:fill-innoveraOrange-400 [&_svg>path]:transition-[fill] [&_svg>path]:duration-[3ms]"
          >
            <InnoveraIcon className="w-6 h-6" />
          </Link>

          <div className="flex items-center gap-[8px] w-max">
            <Avatar className="w-[24px] h-[24px] rounded-[5px]">
              <AvatarFallback className="bg-[#A855F7] text-white rounded-[5px] text-[13px]">
                {avatarLetter}
              </AvatarFallback>
            </Avatar>
            <Typography variant="body2" className="font-normal text-zinc-900 w-full">
              {projectData.name || "New Project"}
            </Typography>
          </div>
        </div>
        <div className="flex items-center justify-center gap-4 w-full"></div>
        {isLabs && <NotificationTrigger projectId={id ? parseInt(id) : undefined} />}
      </div>
      <div className="w-[1px] h-3 bg-innoveraZinc-200 ml-2" />
    </>
  );
}
